import React, {useState, useEffect} from 'react'
import VerCategorias from './VerCategorias.js'
import { MDBInput } from 'mdbreact';
import axios from 'axios'
import fotoVacia from '../../paginas/img/fotoVacia.jpg'
import { recibeImagen, errores } from '../hooks/Funciones'
import moment from 'moment'

const CategoriasAdmin = ({baseUrlCat, Titulo}) => {

	//almacena toda la data de categorias 
	const [data, setData] = useState([])
	//almacena el campo Nombre de categoria
	const [nombre, setNombre] = useState('')
	//almacena el campo activo de categoria
	const [activo, setActivo] = useState(false)
	//almacena la categoria seleccionada
	const [categoriaSelect, setCategoriaSelect] = useState({})
	//selecciona la función como eliminar, crear, editar
	const [funcion, setFuncion] = useState('crear')
	//Alerta del error para la validacion de formulario
	const [alerta, setAlerta] = useState(false)
	const [error, setError] = useState({ activo: false })

	const registroSelect = useState({})
	const [imagenOld, setImagenOld] = useState()

	const [registro, setRegistro] = useState(
		funcion === 'editar' ? categoriaSelect : 
		{ activo: true, imagePrev: fotoVacia, imageCertPrev: fotoVacia })

	//actualiza el registro de la categoria seleccionada
	const actualizarDato = (dato, name) =>{
		setCategoriaSelect({...categoriaSelect, [name]: dato })
	}

	//hace la consulta y trae las categorias y los almacena en data 
	const peticionTraeDatos = async()=>{
		await axios.get(baseUrlCat)
		.then (response => {
			setData(response.data)
			setFuncion('ver')
		})
	}

	//realiza petición que borra de la base de datos por medio de la ID
	const peticionDelete=async()=>{
	    let f = new FormData();
	    f.append("METHOD", "DELETE");
	    await axios.post(baseUrlCat, f, {params: {id: categoriaSelect.id}})
	    .then(response=>{
	      setData(data.filter(categoria=>categoria.id!==categoriaSelect.id))
	      setFuncion('ver')
	    }).catch(error=>{
	      console.log(error)
	    })
	  }

	//Selecciona categoria para editarla o borrarla 
	const SeleccionarCategoria = (objeto, funcion) => e => {
		setFuncion(funcion)
		setCategoriaSelect({
			id: objeto.id,
			activo: objeto.activo === 'true' ? true : false,
			nombre: objeto.nombre,
			padre: objeto.padre,
			imagen: objeto.imagen,
			imagePrev: objeto.imagen
		})

		setImagenOld(objeto.imagen)
		//console.log('objeto',objeto)
		setFuncion(funcion)
	}

	//Consulta para editar campos
	const peticionPut=async()=>{

		const {imagenNueva, nombreImaNueva, imagen} = categoriaSelect

		if (imagenNueva !== undefined) {
			//Cuando Hay una imagen nueva
			let formatosPermitidos = ['.png', '.jpeg', '.jpg', '.JPEG']
			//console.log('imagenNueva', imagenNueva)
			let formato = typeof (imagenNueva) !== "string" ? imagenNueva.type.replace('image/', '.') : null;
			if (imagenNueva !== '' && imagenNueva.size < 2000000 && formatosPermitidos.includes(formato)) {
				//pregunta si existe archivo

				if(categoriaSelect.nombre !== ''){
					let f = new FormData()
					//convierte boleano a cadena
					let cadena = categoriaSelect.activo ? 'true' : 'false'
					f.append("activo", cadena)
					f.append("nombre", categoriaSelect.nombre)
					if (imagenNueva !== undefined) { f.append('nombre_imagen_vieja', imagenOld) }
					f.append('imagen', imagenNueva !== undefined ? imagenNueva : imagen)
					f.append('nombre_imagen', nombreImaNueva)
					f.append("METHOD", "PUT")
					await axios.post(baseUrlCat, f, {params: {id: categoriaSelect.id}})
					.then(response=>{
						peticionTraeDatos()
						setRegistro({ activo: true, imagePrev: fotoVacia, imageCertPrev: fotoVacia })
						setFuncion('ver')
						setAlerta(false)
					}).catch(error=>{
					  console.log(error);
					})
				}else{setAlerta(true)}



			} else { errores('ImagenIncorrecta', setError) }
		
		}else{
			let f = new FormData()
			//convierte boleano a cadena
			let cadena = categoriaSelect.activo ? 'true' : 'false'

			f.append("activo", cadena)
			f.append("nombre", categoriaSelect.nombre)
			f.append('imagen', imagen)
			f.append("METHOD", "PUT")
			await axios.post(baseUrlCat, f, {params: {id: categoriaSelect.id}})
			.then(response=>{
				peticionTraeDatos()
				setRegistro({ activo: true, imagePrev: fotoVacia, imageCertPrev: fotoVacia })
				setFuncion('ver')
				setAlerta(false)
			}).catch(error=>{
				console.log(error);
			})
		}
		//console.log('categoriaSelect', categoriaSelect)
		
	}

	//Consulta para subir o crear los datos 
	const peticionPost = async () =>{

		let {imagen } = registro
		const fecha = moment(new Date()).format("YYYYMMDDHHmmss");

		//console.log('registro',registro)
		if (imagen !== undefined) {

			let formato = imagen.type.replace('image/', '.');
					let NombreImagen = imagen.name.replace(/[^A-Z0-9]+/ig, "_");
					let RutaServ = 'images/'
					let formatosPermitidos = ['.png', '.jpeg', '.jpg']

					if (imagen.size < 2000000 && formatosPermitidos.includes(formato)) {
						let NombreIma = RutaServ + fecha + formato

						if(nombre !== ''){
							let f = new FormData()
							f.append('activo', activo.toString())
							f.append('nombre', nombre)
							f.append('imagen', imagen)
							f.append('nombre_imagen', NombreIma)
							f.append('METHOD', 'POST')
							await axios.post(baseUrlCat, f)
				
							.then(response=>{
							  //setData(data.concat(response.data));
							  peticionTraeDatos()
							  setRegistro({ activo: true, imagePrev: fotoVacia, imageCertPrev: fotoVacia })
							  setNombre('')
							  setActivo(false)
							  setAlerta('')
							}).catch(error=>{
							  console.log(error);
							})
						}else{setAlerta(true)}
					}

		}else{
			if(nombre !== ''){
				let f = new FormData()
				f.append('activo', activo.toString())
				f.append('nombre', nombre)
				f.append('imagen', '')
				f.append('METHOD', 'POST')
				await axios.post(baseUrlCat, f)
	
				.then(response=>{
				  setData(data.concat(response.data));
				  setNombre('')
				  setActivo(false)
				  setAlerta('')
				}).catch(error=>{
				  console.log(error);
				})
			}else{setAlerta(true)}
		}

	}

	//Trae todas las categorias de la api
	useEffect(() => {
		peticionTraeDatos()
	},[])



	return(
		<div>
			<div>
				<br/>
				<h2>{Titulo}:</h2>	
			</div>
			<div className="row">
				{funcion === 'cargando' ? 
					<div className="loader">Loading...</div> 
				:null}
				{funcion === 'ver' ? 
					<div className="col-md-7">
					<VerCategorias 
						data={data} 
						SeleccionarCategoria={SeleccionarCategoria}
						baseUrl={baseUrlCat}
					/>
				</div>
				:null}
				<div className="col-md-5">

					{funcion === 'editar' ?
						<div>
						<h4>Actualizar Categoria</h4>
						<hr/>
						<div className='custom-control custom-switch '>
					        <input
					          type='checkbox'
					          name="activo"
					          className='custom-control-input form-control-lg mb-4'
					          id='customSwitches'
					          checked={categoriaSelect.activo}
					          onChange={e => actualizarDato(e.target.checked, e.target.name)}
					          readOnly
					        />
					        <label className='custom-control-label' htmlFor='customSwitches'>
					          Activar/Desactivar
					        </label>
			      		</div>
						<MDBInput 
							label="Nombre Categoría" 
							onChange={e => actualizarDato(e.target.value, e.target.name)}
							name="nombre"
							className={alerta ? "form-control is-invalid" : null}
							value={categoriaSelect && categoriaSelect.nombre}
							outline />
						<div>
								<div className='PublicidadProd'>
									<h4>Imagen:</h4>
									<div className="FotoPrev">
														<img alt="imagen" src={
															categoriaSelect.imagePrev === categoriaSelect.imagen ?
																baseUrlCat + "/" + categoriaSelect.imagePrev
																: categoriaSelect.imagePrev
														} />
									</div>
								</div>

								<br></br>
								<div className="input-group">
									<div className="input-group-prepend">
									</div>
									<div className="custom-file">
										<input type="file" className="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01"
											name="imagen"
											onChange={recibeImagen(categoriaSelect, setCategoriaSelect, 'editar')}
										/>
										<label className="custom-file-label">
											Seleccionar Foto
										</label>
									</div>
								</div>
							</div>
						<div className="col text-center">
								<button 
									onClick={peticionPut}
									className="btn boton_estandar"							
									>Actualizar Categoría
								</button>
								<button 
									onClick={e=>setFuncion('ver')}
									className="btn boton_estandar"							
									>Cancelar
								</button>
						</div>
						</div>
					: null}

					{funcion === 'ver' ?

						<div>
							<h4>Subir Categoria</h4>
							<hr/>
							<div className='custom-control custom-switch '>
								<input
								type='checkbox'
								name="activo"
								className='custom-control-input form-control-lg mb-4'
								id='customSwitches'
								checked={activo}
								onChange={e => setActivo(!activo)}
								readOnly
								/>
								<label className='custom-control-label' htmlFor='customSwitches'>
								Activar/Desactivar
								</label>
							</div>
							<MDBInput 
								label="Nombre Categoría" 
								value={nombre}
								onChange={e => setNombre(e.target.value)}
								name="nombre"
								required
								className={alerta ? "form-control is-invalid" : null}
								outline />
							
							<div>
								<div className='PublicidadProd'>
									<h4>Imagen:</h4>
									<div className="FotoPrev">

										{funcion === 'editar' ?
											<img alt="imagen" src={
												registro.imagePrev === registro.imagen ?
													baseUrlCat + "/" + registro.imagePrev
													: registro.imagePrev
											} />
											:
											<img src={registro.imagePrev} />
										}
									</div>
								</div>

								<br></br>
								<div className="input-group">
									<div className="input-group-prepend">
									</div>
									<div className="custom-file">
										<input type="file" className="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01"
											name="imagen"
											onChange={recibeImagen(registro, setRegistro, 'crear')}
										/>
										<label className="custom-file-label">
											Seleccionar Foto
										</label>
									</div>
								</div>
							</div>
							<br />


							<div className="col text-center">
								<button 
									onClick={peticionPost}
									className="btn boton_estandar"							
									>Subir Categoría
								</button>
							</div>
						</div>
					:null}

					{funcion === 'eliminar' ?

						<div>
						<h4>¿Desea Realmente Eliminar?</h4>
						<hr/>
						<div className="col text-center">

							<p>Categoria: {categoriaSelect.nombre}</p>
							<button 
								onClick={peticionDelete}
								className="btn boton_estandar"							
								>Eliminar
							</button>
							
						</div>
						</div>
					:null}
				</div>
			</div>
		</div>
	)
}

export default CategoriasAdmin